module.exports = "<div class=\"modal-header\">\n    <h2> Non puoi attivare prenota ritiro e non specificare i periodi di erogazione del servizio </h2>\n</div>\n<p></p>\n<p>Per favore per proseguire specifica almeno una fascia oraria oppure disattiva la modalità prenota ritiro, grazie </p>\n<footer>\n    <button class=\"button\" ng-click=\"close()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}}\n    </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/orderAndPick/openingHoursEmptyAdviseModal.html
 ** module id = 526
 ** module chunks = 0
 **/